import React, { useState } from "react";
import { Checkbox, Modal, Typography } from "antd";
import DateSelectionForm from "components/DateSelectionForm";

interface Props {
  /** Receives {from, to} as YYYY-MM-DD (both inclusive), plus override when withOverride is set. */
  onStart: (params: { from: string; to: string; override?: boolean }) => void;
  onlyPast?: boolean;
  /** Shows the "Override existing values" checkbox (default off); a confirmation popup appears only when it is ticked. */
  withOverride?: boolean;
}

// Start control for jobs over a date range: the existing range picker, sending {from, to} (+ override).
const DateRangeStart: React.FC<Props> = ({ onStart, onlyPast, withOverride }) => {
  const [override, setOverride] = useState(false);
  return (
    <>
      {withOverride ? (
        <div style={{ marginBottom: 12 }}>
          <Checkbox checked={override} onChange={(e) => setOverride(e.target.checked)}>
            Override existing values
          </Checkbox>
          <div>
            <Typography.Text type="secondary">
              Off (default): dates that already have a value keep it. On: values already stored for these dates are
              replaced with this job's output (provider price or carry-forward).
            </Typography.Text>
          </div>
        </div>
      ) : null}
      <DateSelectionForm
        onlyPast={onlyPast}
        onSubmit={(dates) => {
          if (dates.length === 0) {
            return;
          }
          const params: { from: string; to: string; override?: boolean } = {
            from: dates[0],
            to: dates[dates.length - 1],
          };
          if (!withOverride) {
            onStart(params);
            return;
          }
          params.override = override;
          if (!override) {
            onStart(params);
            return;
          }
          Modal.confirm({
            title: "Override existing values?",
            content: `Values already stored for ${params.from} → ${params.to} will be replaced with this job's output.`,
            okText: "Override",
            okButtonProps: { danger: true },
            onOk: () => onStart(params),
          });
        }}
      />
    </>
  );
};

export default DateRangeStart;
